import { travel } from '../../utils/tree'
import { capitalize } from '../../utils/string'
import { i18n } from '../../helper/i18n/index'

export default {
  render(h) {
    return (
      <div class="sp-breadcrumb-container">
        <i class="el-icon-location-outline"></i>
        <el-breadcrumb separatorClass="el-icon-arrow-right">
          {this.arr.map(item => (
            <el-breadcrumb-item>{i18n(capitalize(item))}</el-breadcrumb-item>
          ))}
        </el-breadcrumb>
      </div>
    )
  },
  props: {
    data: Array
  },
  data () {
    return {
      arr: travel(this.data, this.$route.path)
    }
  },
  watch: {
    '$route': function (newRoute) {
      this.arr = travel(this.data, newRoute.path)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/components/Breadcrumb/index.js